export default "__VITE_ASSET__DBj9ExEg__"